import React, { useEffect, useRef, useState } from "react";
import { ScrollView, View } from "react-native";
import WebView from "react-native-webview";
import { IconSizeTokens, IconTokens } from "@voltmoney/schema";
import PartnerCheckLimitDetailsCard from "../../partnerCheckLimitCard/PartnerCheckLimitDetailsCard";
import { isMobileView } from "../../stack/utils";
import { showShareLink } from "../utils";
const PartnerInterestCalculator = ({ height, shareLinkAction, baseLink, triggerAction }) => {
    const containerRef = useRef(null);
    const _isMobile = isMobileView();
    const [iframeHeight, setIFrameHeight] = useState(400);
    const [showLink, setShowLink] = useState(showShareLink());
    const handleIframeMessage = (event) => {
        if (event?.data?.data && event?.data?.id === 'getDimensionLeads') {
            setIFrameHeight(event?.data?.data);
        }
        if (event?.data?.data && event?.data?.id === 'handleMessageSendOnFullScheduleClick') {
            const x = event?.data?.data?.position?.x;
            const y = event?.data?.data?.position?.y;
            containerRef?.current?.scrollTo({ x: parseInt(x), y: parseInt(y), animated: true });
        }
    };
    useEffect(() => {
        window.addEventListener('message', handleIframeMessage);
        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, []);
    useEffect(() => {
        window.addEventListener('message', handleIframeMessage);
        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, [_isMobile]);
    const renderShareCards = () => {
        return (React.createElement(PartnerCheckLimitDetailsCard, { title: 'Share with your customer', subTitle: 'Invite your customers to check their credit limit in just 15s', icon: {
                name: IconTokens.Share4,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            }, actionItems: shareLinkAction ? [
                {
                    title: 'Share link \u276F',
                    action: shareLinkAction
                }
            ] : [], isMobile: _isMobile, triggerAction: triggerAction }));
    };
    const renderCheckLimitManuallyCard = () => {
        return (React.createElement(PartnerCheckLimitDetailsCard, { title: 'Check limit manually', subTitle: 'No OTP is required. Check limit based on fund name', icon: {
                name: IconTokens.Meter_1,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            }, isMobile: _isMobile, showComingSoon: true, actionItems: [] }));
    };
    const renderIframe = () => {
        return (React.createElement(WebView, { source: { uri: _isMobile
                    ? `${baseLink}interest-calculator-iframe?isMobileView=true`
                    : `${baseLink}interest-calculator-iframe`
            }, style: {
                flex: 1,
            } }));
    };
    return (React.createElement(ScrollView, { ref: containerRef, style: {
            width: '100%',
            height: height - 65,
            // overflow: 'scroll',
            paddingHorizontal: 16,
        }, contentContainerStyle: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        } },
        React.createElement(View, { style: { height: 24 } }),
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflow: 'hidden',
                maxWidth: 730,
                width: '100%',
                height: iframeHeight + 20,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: '#FFF',
                backgroundColor: '#FFF',
                shadowColor: '#000',
                shadowOffset: {
                    width: 0,
                    height: 3,
                },
                shadowOpacity: 0.1,
                shadowRadius: 12,
                elevation: 3, // for Android,
            } }, renderIframe()),
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                maxWidth: 730,
            } },
            React.createElement(View, { style: { height: 24 } }),
            React.createElement(View, { style: {
                    width: '100%',
                    height: 1,
                    backgroundColor: '#E4E7EC'
                } }),
            React.createElement(View, { style: { height: 24 } }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: _isMobile ? 'column' : 'row',
                } },
                showLink && renderShareCards(),
                showLink && React.createElement(View, { style: _isMobile ? { height: 24 } : { width: 24 } }),
                renderCheckLimitManuallyCard())),
        React.createElement(View, { style: { height: 24 } })));
};
export default PartnerInterestCalculator;
